



/* Built In Imports */

/* External Imports */
import { Box } from '@chakra-ui/react';
import config from '@config';
import ProgramStructureCard from '@landing_pages/ieo/Sections/ProgramStructureCard';
import { useState } from 'react';
import { useMediaQuery } from 'react-responsive';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
/* Internal Imports */
/* Components */

/**
 * Renders the ImageBannerAd Card component
 *
 * @param sectionContent.sectionContent
 * @param {object} sectionContent - Data for section
 * @param {string} region - Region for page
 * @param {Sting} lang - Language for page
 * @param sectionContent.region
 * @param sectionContent.lang
 * @param sectionContent.width
 * @param sectionContent.height
 * @param sectionContent.my
 * @param sectionContent.display
 * @param sectionContent.maxW
 * @returns {ReactElement} ImageBannerAd component
 */
const PracticeCurriculumCard = ({
  sectionContent, region, language, pageName
}) => {


  const isMobile = useMediaQuery({ maxWidth: 767 });
  const isTab = useMediaQuery({ maxWidth: 1024 });
  const [imgIndex, setImgIndex] = useState(0);
  const [slidecount, setSlidecount] = useState('');
  const [currentimage, setCurrentimage] = useState('');
  const updatecount = (props, obj) => {
    let currentslide = props.currentSlide === 0 && isMobile || isTab ? 1 : props?.currentSlide === 0 ? 3 : props?.currentSlide;
    if (obj === 'next' && props.currentSlide !== 0) {
      const remainingSlides = props.slideCount - props.currentSlide;
      currentslide = isMobile || isTab ? props?.currentSlide + 1 : props.currentSlide + (remainingSlides > 3 ? 3 : remainingSlides);
    }

    setCurrentimage(currentslide);
  };
  const NextArrow = props => {
    const { onClick } = props;
    updatecount(props, 'next');
    return (
      <Box
        pos="absolute"
        top={{ base: "110px", sm: "110px", md: "120px" }}
        right={{
          base: "-20px", sm: "-20px", md: "-20px", xl: "0px"
        }}
        zIndex="10"
        cursor="pointer"
        bgSize="10px"
        bgColor="#fff"
        border="0"
        borderRadius="100%"
        w={{
          base: "40px", md: "62px", lg: "45px"
        }
        }
        h={{
          base: "40px", md: "62px", lg: "45px"
        }}
        boxShadow="0 0 10px rgba(0, 0, 0, 0.5)"
        bgPos="center"
        bgRepeat="no-repeat"
        color="transparent"
        bgImage={`url(${config.staticPath}/assets/images/right-arrow.svg)`}
        onClick={onClick}
      ></Box >
    );
  };
  const PrevArrow = props => {
    const { onClick } = props;
    updatecount(props, 'prev');
    return (
      <Box
        pos="absolute"
        top={{ base: "110px", sm: "110px", md: "120px" }}
        left={{ base: "-20px", sm: "-20px", md: "-20px" }}
        zIndex="10"
        cursor="pointer"
        bgSize="10px"
        bgColor="#fff"
        border="0"
        borderRadius="100%"
        w={{
          base: "40px", md: "62px", lg: "45px"
        }}
        h={{
          base: "40px", md: "62px", lg: "45px"
        }}
        boxShadow="0 0 10px rgba(0, 0, 0, 0.5)"
        bgPos="center"
        bgRepeat="no-repeat"
        color="transparent"
        bgImage={`url(${config.staticPath}/assets/images/left-arrow.svg)`
        }
        // className={`${classes["meetSlick-arrow"]} ${classes.meetPrevArrow}`}
        onClick={onClick}
      />
    );
  };

  const settings = {
    infinite: true,
    lazyLoad: true,
    autoplay: false,
    arrows: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    className: "other-aspects",
    appendDots: dots => (
      <Box h="1px">
        {/* <List margin='0px'> {dots} </List> */}
      </Box>
    ),
    customPaging: () => (
      <Box
        marginTop={"10px"}
        background={'#D2C8B5'}
        width="12px"
        rounded="full"
        height="12px"
      ></Box>
    ),
    afterChange: (index) => setImgIndex(index),
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 1,
          arrows: true,
          dots: true,
        },
      },
      {
        breakpoint: 1065,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          dots: true,
          // centerPadding: '0px 40px',

        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          dots: false,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          dots: false,
          // centerPadding: '0px 40px',

        }
      }
    ],
  };

  return (
    <>

      <Box
        height={"280px"}
        // float="left"
        w="100%"
        // marginLeft={{ base: "20px", sm: "20px", md: "140px" }}
        // marginRight={{ base: "30px", sm: "30px", md: "" }}
        // gap={"10px"}
        marginTop={"52px"}
        // maxWidth={"1060px"}
        gap={"20px"}
        position={"relative"}
      >
        <Slider {...settings}>
          {sectionContent?.cards?.map(section => {
            return <Box
              display="flex"
              flexDirection="column"
              maxWidth={{ base: "", md: "322px" }}
            // height={"330px"}
            // marginLeft={{ base: "0px", sm: "0px", md: "130px", lg: "0px" }}

            >
              <ProgramStructureCard pageName={pageName} data={section} lang={'en'} />
            </Box>
          })}
        </Slider>
        <Box
          textAlign="center"
          fontFamily="FedraSansStd-book, sans-serif"
          fontSize="16px"
          fontWeight="600"
          pb="35px"
          mt={{ base: "-20px", sm: "-20px", md: "0px", lg: "" }}
          color={"black"}

        >
          {currentimage} / {sectionContent?.cards?.length}
        </Box>
      </Box >

    </>
  );
};

export default PracticeCurriculumCard;
